export const USER_KEY = 'user_key'
export const USER_FORM_VALUES = 'user_form_values'
export const TERM_KEY = 'term_key'
export const USER_CARD = 'user_card'
// export const REIMBURSEMENTITEM_KEY = 'reimbursement_key'
export const FORM_VALUE = 'form_value'
// export const FORM_VALUE_USER = 'form_value_user'
export const REIMBURSEMENT_ID = 'reimbursement_id'
